import React, { useState } from 'react';
import { useAppContext } from '../../../AppContext';
import Dropdown from '../../../core/components/Dropdown/Dropdown';
import SessionStorageService from '../../../core/services/SessionStorageService';
import { ILanguage, LanguageCode } from '../../../core/types/ILanguage';
// @ts-ignore
import classNames from 'classnames';

const LanguageSwitcher = () => {
    const [isOpenDropdown, setIsOpenDropdown] = useState<boolean>(false);
    
    const { languages , currentLanguage} = useAppContext();

    const handleOnClick = (code: LanguageCode) => {
        setIsOpenDropdown(!isOpenDropdown);
        SessionStorageService.set('selectedLanguage', code);

        window.location.reload(true);
    };

    const toggleDropdown = () => {
        setIsOpenDropdown(!isOpenDropdown);
    };

    return (
        <>
            <Dropdown isOpen={isOpenDropdown} toggle={toggleDropdown}>
                <>
                    <Dropdown.Header>
                        <i className={classNames(
                            'c-flag c-flag--en-us',
                            currentLanguage ?  `c-flag--${currentLanguage}` : 'c-flag--en-us'
                        )} />
                    </Dropdown.Header>

                    <Dropdown.List classNames="c-dropdown-list">
                        {languages?.map((lang: ILanguage) => (
                            <Dropdown.ListItem key={lang.code} onClick={() => handleOnClick(lang.code)}>
                                <i className={`c-flag c-flag--${lang.code} mr-2`} />
                                {lang.name}
                            </Dropdown.ListItem>
                        ))}
                    </Dropdown.List>
                </>
            </Dropdown>  
        </>
    )
}

export default React.memo(LanguageSwitcher);